import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { MAX_CONTENT_WIDTH } from 'modules/UI/constants';

export const Content = styled.div`
  max-width: ${MAX_CONTENT_WIDTH};
  width: 100%;
  margin: auto;
  padding: 0 ${tokens.space.regular};
  box-sizing: border-box;
`;

export const MiddleBackground = styled.div`
  position: absolute;
  display: block;
  background-color: ${tokens.colors.grayLight};
  width: 100%;
  height: 280px;
  top: 1259px;
  z-index: -1;

  ${tokens.mediaQueries.s} {
    display: none;
  }
`;
